import { render, staticRenderFns } from "./HealthChecks.vue?vue&type=template&id=b5632fca&scoped=true&"
import script from "./HealthChecks.vue?vue&type=script&lang=js&"
export * from "./HealthChecks.vue?vue&type=script&lang=js&"
import style0 from "./HealthChecks.vue?vue&type=style&index=0&id=b5632fca&prod&scoped=true&lang=scss&"
import style1 from "./HealthChecks.vue?vue&type=style&index=1&id=b5632fca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5632fca",
  null
  
)

export default component.exports